import React, { useEffect, useState } from "react";
import Nav from "../../Components/Navbar/Nav";
import Footer from "../../Components/Footer/Footer";
import eve from "./eve.module.css";
import { fetchEvents, imageUrl, registerForEvent } from "../../Api/PostManApi";

const convertEventDate = (date) => {
  const eventDate = new Date(date);

  const weekday = eventDate.toLocaleString("en-US", { weekday: "long" });
  const month = eventDate.toLocaleString("en-US", { month: "long" });
  const day = eventDate.getDate();
  const year = eventDate.getFullYear();
  let hours = eventDate.getHours();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  return `${weekday}, ${month} ${day}, ${year}. TIme: ${hours}${ampm}`;
};
const RegistrationForm = ({ eventId, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log("Form submitted:", formData);
      await registerForEvent(eventId, formData);

      alert(
        `Thanks ${formData.name}! You've registered for this event. We'll contact you at ${formData.email}`
      );
      onClose();
    } catch (error) {
      console.error("Registration failed:", error);
      alert(`Sorry, we couldn't register you at this time: ${error.message}`);
    }
  };

  return (
    <div className="mt-4 bg-purple-50 p-6 rounded-lg border border-purple-100">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-purple-800">
          Registration Form
        </h3>
        <button
          onClick={onClose}
          className="text-purple-600 hover:text-purple-800"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label
            htmlFor="name"
            className="block text-sm font-medium text-purple-700"
          >
            Name
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 bg-white border border-purple-300 rounded-md shadow-sm focus:outline-none focus:ring-purple-500 focus:border-purple-500"
            placeholder="Your name"
            required
          />
        </div>

        <div>
          <label
            htmlFor="email"
            className="block text-sm font-medium text-purple-700"
          >
            Email
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 bg-white border border-purple-300 rounded-md shadow-sm focus:outline-none focus:ring-purple-500 focus:border-purple-500"
            placeholder="your.email@example.com"
            required
          />
        </div>

        <div className="pt-2">
          <button
            type="submit"
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition-colors"
          >
            Complete Registration
          </button>
        </div>
      </form>
    </div>
  );
};

const UpcomingEvents = () => {
  const [apievents, setEvent] = useState([]);
  const [showFormForEvent, setShowFormForEvent] = useState(null);

  useEffect(() => {
    const allEvents = async () => {
      const result = await fetchEvents();
      const gottenEvent = Array.isArray(result)
        ? result
        : Array.isArray(result.data)
        ? result.data
        : result;
      setEvent(gottenEvent);
      console.log("result for events", result);
    };
    allEvents();
  }, []);

  const toggleForm = (eventId) => {
    setShowFormForEvent(showFormForEvent === eventId ? null : eventId);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Nav />
      <div className={eve.eve}>
        <div className={eve.container}>
          <main className="flex-grow mt-8 px-4 py-8">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center">
                {apievents.map((event) => (
                  <div
                    key={event?._id}
                    className="bg-white shadow-lg rounded-lg overflow-hidden w-full max-w-md transition-transform hover:scale-105 flex flex-col"
                  >
                    <img
                      src={`${imageUrl}/event_imgs/${event?.image}`}
                      alt={event?.title}
                      className="w-full h-56 object-cover"
                    />
                    <div className="flex-grow p-6">
                      <h2 className="text-2xl font-semibold text-blue-600">
                        {event?.title}
                      </h2>
                      <p className="text-gray-500">
                        {convertEventDate(event?.time)}
                      </p>
                      <div className="flex items-center gap-2">
                        <svg
                          fill="#2d9a43"
                          version="1.1"
                          id="Capa_1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          width="16px"
                          height="16px"
                          viewBox="0 0 395.71 395.71"
                          xmlSpace="preserve"
                          stroke="#2d9a43"
                          className="flex-shrink-0" // Prevent icon from shrinking
                        >
                          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                          <g
                            id="SVGRepo_tracerCarrier"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></g>
                          <g id="SVGRepo_iconCarrier">
                            <g>
                              <path d="M197.849,0C122.131,0,60.531,61.609,60.531,137.329c0,72.887,124.591,243.177,129.896,250.388l4.951,6.738 c0.579,0.792,1.501,1.255,2.471,1.255c0.985,0,1.901-0.463,2.486-1.255l4.948-6.738c5.308-7.211,129.896-177.501,129.896-250.388 C335.179,61.609,273.569,0,197.849,0z M197.849,88.138c27.13,0,49.191,22.062,49.191,49.191c0,27.115-22.062,49.191-49.191,49.191 c-27.114,0-49.191-22.076-49.191-49.191C148.658,110.2,170.734,88.138,197.849,88.138z"></path>
                            </g>
                          </g>
                        </svg>
                        <p className="text-gray-500 text-sm truncate">
                          {event?.address}
                        </p>
                      </div>
                    </div>
                    <div className="px-6 pb-6">
                      <button
                        onClick={() => toggleForm(event._id)}
                        className="mt-4 bg-gradient-to-r from-blue-600 to-blue-500 text-white py-4 px-6 rounded-lg hover:from-blue-700 hover:to-blue-600 transition-all duration-300 w-full flex items-center justify-center font-medium text-lg shadow-md hover:shadow-lg"
                      >
                        <span>
                          {showFormForEvent === event?._id
                            ? "Cancel"
                            : "Register"}
                        </span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 ml-2"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>

                      {showFormForEvent === event._id && (
                        <RegistrationForm
                          eventId={event._id}
                          onClose={() => setShowFormForEvent(null)}
                        />
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default UpcomingEvents;
